import React from "react";
import { Loader2 } from "lucide-react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../lib/auth";

export default function AdminRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen grid place-items-center" data-testid="admin-loading">
        <Loader2 className="animate-spin text-inkSoft" size={20} />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (!user.is_admin) {
    return (
      <div className="min-h-screen grid place-items-center px-6 text-center">
        <div>
          <div className="eyebrow mb-2">Admin only</div>
          <h1 className="font-display text-3xl font-bold tracking-tight">You don't have admin access.</h1>
          <p className="text-inkSoft mt-3 max-w-md">Visit <span className="font-mono">/admin/access</span> and use the agency promotion secret to unlock this area.</p>
        </div>
      </div>
    );
  }
  return children;
}
